import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ReactExport from "react-export-excel";
import moment from "moment";
import CustomTable from "../../../../components/CustomTable";
import CustomPagint from "../../../../components/CustomPagint";
import {
  getDisciplinaryActions,
  deleteDisciplinaryActions,
  saveDisciplinaryActionDocGD,
  editDisciplinaryActionDocGD,
} from "../../../../redux/Modulo_Sanciones/Disciplinary_Actions/actions";
import {
  getAreas,
  getCarpetas,
  getSubNiveles,
} from "../../../../redux/gestorDocumental/actions";
import messages from "../../../../redux/messages";
import DisciplinaryActionsModal from "../../../../components/Modulo_Sanciones/Disciplinary_Actions_Modal";
import DisciplinaryCaseModal from "../../../../components/Modulo_Sanciones/Disciplinary_Case_Modal";
import config from "../../../../config";
import LinkDescargaGD from "../../../../components/gestorDocumental/LinkDescargaGD";
import LinkDescargaListGD from "../../../../components/gestorDocumental/LinkDescargaListGD";
import { getBase64 } from "../../../../components/gestorDocumental/GestorDocumental";
import {
  getDisciplinaryCasesAll,
  resetDisciplinaryCase,
} from "../../../../redux/Modulo_Sanciones/diciplinarycase/actions";
import { getStatuss } from "../../../../redux/Modulo_Sanciones/status/actions";


const filters = [
  { id: "empleado__codigo", desc: "Código de empleado" },
  { id: "empleado", desc: "Nombre de empleado" },
  { id: "estatus", desc: "Estatus" },
];

function ReincidenciasAccionesEmployee(props) {
  const {
    employeeCode,
    onClose,
    employeeName,
    toggleButtonsVisibility /* getRecidivismActions */,
  } = props;
  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [tipoBusqueda] = useState(filters[0]);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showModalCase, setShowModalCase] = useState(false);
  const [filter, setFilter] = useState("");
  const [editItemGD, setEditItemGD] = useState({});
  const [editItemIndex, setEditItemIndex] = useState(0);
  const [habilitarFecha, setHabilitarFecha] = useState(false);
  const [showModalView, setShowModalView] = useState(false);
  const [validatedDoc, setValidatedDoc] = useState(false);
  const [validFechaDoc, setValidFechaDoc] = useState(false);
  const [view, setView] = useState("");

  const dispatch = useDispatch();

  const { userRoles } = useSelector((store) => store.auth);
  const {
    loading,
    disciplinaryActionsLength,
    disciplinaryActions,
    disciplinaryActionsError,
    saveLoading,
  } = useSelector((store) => store.disciplinaryActions);
  const pages = Math.ceil(disciplinaryActionsLength / limit);

  const { loaderDiciplinaryCasesAll: loaderDiciplinaryCases } = useSelector(
    (store) => store.disciplinaryCase
  );

  const {
    areas,
    carpetas,
    subNiveles,
    formErrors,
    loadingDocs,
    loadingAreas,
    loadingCarpetas,
    saveDocsLoading,
    subNivelesError,
  } = useSelector((store) => store.gestorDocumental);
  const { carpeta, tipoDocumento, tipoDocumentoGD, descripcion } =
    config.gestorDocumental.accion_disciplinaria;
  const { area, email } = config.gestorDocumental;

  const columns = [
    {
      Header: "Caso disciplinario",
      accessor: "list_caso_disciplinario[0].caso_disciplinario",
      Filter: "",
    },
    {
      Header: "Código empleado",
      accessor: "list_caso_disciplinario[0].list_codigo_empleado[0].codigo",
      Filter: "",
    },
    {
      Header: "Colaborador",
      accessor: "list_caso_disciplinario[0].list_codigo_empleado[0].nombre",
      Filter: "",
    },
    {
      Header: "Acción Disciplinaria",
      accessor: "list_caso_disciplinario[0].list_id_motivo[0].nombre",
      Filter: "",
    },
    {
      Header: "Descripción",
      accessor: "list_caso_disciplinario[0].descripcion",
      Filter: "",
    },
    {
      Header: "Aplicado por",
      accessor: "list_aplicada_por[0].first_name",
      Filter: "",
      Cell: (value) => (
        <div className="d-flex justify-content-between">
          <p>
            {value.row.original.list_aplicada_por[0].last_name
              ? `${value.row.original.list_aplicada_por[0].first_name} ${value.row.original.list_aplicada_por[0].last_name}`
              : value.row.original.list_aplicada_por[0].first_name}
          </p>
        </div>
      ),
    },
    {
      Header: "Observación",
      accessor: "observacion",
      Filter: "",
    },
    {
      Header: "Fecha de vencimiento",
      Filter: "",
      Cell: (value) =>
        moment(value.row.original.fecha_vencimiento).format("DD/MM/YYYY"),
    },
    {
      id: "status",
      Header: "Estatus",
      Cell: (value) => (
        <div
          className="p-2 rounded-pill text-white text-center"
          style={{
            minWidth: "90px",
            backgroundColor:
              value.row.original.list_caso_disciplinario &&
              value.row.original.list_caso_disciplinario[0].list_estatus
                ? value.row.original.list_caso_disciplinario[0].list_estatus[0]
                    .color_a_mostrar
                : null,
          }}
        >
          {value.row.original.list_caso_disciplinario &&
          value.row.original.list_caso_disciplinario[0].list_estatus
            ? value.row.original.list_caso_disciplinario[0].list_estatus[0]
                .nombre
            : null}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Editar</Tooltip>}
          >
            <Button
              size="sm"
              variant="link"
              type="button"
              onClick={() => onEdit(value.row.original, value.row.index)}
            >
              <i className="material-icons">edit</i>
            </Button>
          </OverlayTrigger>
          {(view === "Responsable_Sanciones" ||
            view === "Encargado_Sanciones" ||
            view === "administrador") && (
            <>
              <OverlayTrigger
                placement="auto"
                overlay={<Tooltip {...props}>Eliminar</Tooltip>}
              >
                <Button
                  size="sm"
                  className="text-danger"
                  variant="link"
                  type="button"
                  onClick={() =>
                    onDelete(value.row.original.id, value.row.index)
                  }
                >
                  <i className="material-icons">close</i>
                </Button>
              </OverlayTrigger>
            </>
          )}
          <ExcelFile
            element={
              <OverlayTrigger
                placement="auto"
                overlay={<Tooltip {...props}>Exportar excel</Tooltip>}
              >
                <Button
                  size="sm"
                  variant="link"
                  type="button"
                  className="text-info"
                >
                  <i className="material-icons">file_present</i>
                </Button>
              </OverlayTrigger>
            }
          >
            <ExcelSheet data={[value.row.original]} name="Acción disciplinaria">
              <ExcelColumn
                label="Caso disciplinario"
                value={(col) =>
                  col.list_caso_disciplinario[0].caso_disciplinario
                    ? col.list_caso_disciplinario[0].caso_disciplinario
                    : null
                }
              />
              <ExcelColumn
                label="Acción Disciplinaria"
                value={(col) =>
                  col.list_caso_disciplinario[0].list_id_motivo[0].nombre
                    ? col.list_caso_disciplinario[0].list_id_motivo[0].nombre
                    : null
                }
              />
              <ExcelColumn
                label="Descripción"
                value={(col) =>
                  col.list_caso_disciplinario[0].descripcion
                    ? col.list_caso_disciplinario[0].descripcion
                    : null
                }
              />
              <ExcelColumn
                label="Aplicada por"
                value={(col) =>
                  col.list_aplicada_por[0].first_name
                    ? col.list_aplicada_por[0].first_name +
                      " " +
                      col.list_aplicada_por[0].last_name
                    : null
                }
              />
              <ExcelColumn
                label="Observación"
                value={(col) => col.observacion}
              />
              <ExcelColumn
                label="Autorizado por"
                value={(col) => col.autorizado_por}
              />
              <ExcelColumn
                label="Fecha vencimiento"
                value={(col) =>
                  col.fecha_vencimiento
                    ? moment(col.fecha_vencimiento).format("DD/MM/YYYY")
                    : null
                }
              />
              <ExcelColumn
                label="fecha_creacion"
                value={(col) =>
                  col.fecha_creacion
                    ? moment(col.fecha_creacion).format("DD/MM/YYYY")
                    : null
                }
              />
            </ExcelSheet>
            <ExcelSheet data={[value.row.original]} name="Caso disciplinario">
              <ExcelColumn
                label="Caso disciplinario"
                value={(col) =>
                  col.list_caso_disciplinario[0].caso_disciplinario
                    ? col.list_caso_disciplinario[0].caso_disciplinario
                    : null
                }
              />
              <ExcelColumn
                label="Empleado"
                value={(col) =>
                  col.list_caso_disciplinario[0].list_codigo_empleado[0].nombre
                    ? col.list_caso_disciplinario[0].list_codigo_empleado[0]
                        .nombre
                    : null
                }
              />
              <ExcelColumn
                label="Creado por"
                value={(col) =>
                  col.list_caso_disciplinario[0].list_creado_por[0].first_name
                    ? col.list_caso_disciplinario[0].list_creado_por[0]
                        .first_name +
                      " " +
                      col.list_caso_disciplinario[0].list_creado_por[0]
                        .last_name
                    : null
                }
              />
              <ExcelColumn
                label="Estatus"
                value={(col) =>
                  col.list_caso_disciplinario[0].list_estatus[0].nombre
                    ? col.list_caso_disciplinario[0].list_estatus[0].nombre
                    : null
                }
              />
              <ExcelColumn
                label="Número de ticket"
                value={(col) =>
                  col.list_caso_disciplinario[0].numero_ticket
                    ? col.list_caso_disciplinario[0].numero_ticket
                    : null
                }
              />
              <ExcelColumn
                label="Tipo de acción disciplinaria"
                value={(col) =>
                  col.list_caso_disciplinario[0].list_accion_disciplinaria[0]
                    .nombre
                    ? col.list_caso_disciplinario[0]
                        .list_accion_disciplinaria[0].nombre
                    : null
                }
              />
              <ExcelColumn
                label="Motivo"
                value={(col) =>
                  col.list_caso_disciplinario[0].list_id_motivo[0].nombre
                    ? col.list_caso_disciplinario[0].list_id_motivo[0].nombre
                    : null
                }
              />
              <ExcelColumn
                label="Fecha vencimiento"
                value={(col) =>
                  col.list_caso_disciplinario[0].fecha_vencimiento
                    ? moment(
                        col.list_caso_disciplinario[0].fecha_vencimiento
                      ).format("DD/MM/YYYY")
                    : null
                }
              />
              <ExcelColumn
                label="Fecha creación"
                value={(col) =>
                  col.list_caso_disciplinario[0].fecha_creacion
                    ? moment(
                        col.list_caso_disciplinario[0].fecha_creacion
                      ).format("DD/MM/YYYY")
                    : null
                }
              />
              <ExcelColumn
                label="Tipo de Falta"
                value={(col) =>
                  col.list_caso_disciplinario[0].list_id_tipo_falta[0].nombre
                    ? col.list_caso_disciplinario[0].list_id_tipo_falta[0]
                        .nombre
                    : null
                }
              />
              <ExcelColumn
                label="Descripción"
                value={(col) =>
                  col.list_caso_disciplinario[0].descripcion
                    ? col.list_caso_disciplinario[0].descripcion
                    : null
                }
              />
              <ExcelColumn
                label="Plantilla Workflow"
                value={(col) =>
                  col.list_caso_disciplinario &&
                  col.list_caso_disciplinario[0].list_workflow &&
                  col.list_caso_disciplinario[0].list_workflow[0].nombre
                    ? col.list_caso_disciplinario[0].list_workflow[0].nombre
                    : null
                }
              />
              <ExcelColumn
                label="Encargado de la plantilla Workflow"
                value={(col) =>
                  col.list_caso_disciplinario &&
                  col.list_caso_disciplinario[0].list_workflow &&
                  col.list_caso_disciplinario[0].list_workflow[0]
                    .datos_responsable &&
                  col.list_caso_disciplinario[0].list_workflow[0]
                    .datos_responsable[0].first_name
                    ? col.list_caso_disciplinario[0].list_workflow[0]
                        .first_name +
                      " " +
                      col.list_caso_disciplinario[0].list_workflow[0].last_name
                    : null
                }
              />
            </ExcelSheet>
          </ExcelFile>
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Detalle caso disciplinario</Tooltip>}
          >
            <Button
              size="sm"
              variant="link"
              type="button"
              className="text-dark"
              disabled={
                loaderDiciplinaryCases &&
                value.row.original.caso_disciplinario === null
              }
              onClick={() =>
                onOpenModalCase(value.row.original, value.row.index)
              }
            >
              <i className="material-icons">gavel</i>
            </Button>
          </OverlayTrigger>
          {value.row.original.list_caso_disciplinario &&
            value.row.original.list_caso_disciplinario[0]
              .list_codigo_empleado &&
            (view === "Responsable_Sanciones" ||
              view === "Encargado_Sanciones" ||
              view === "administrador") && (
              <>
                <OverlayTrigger
                  placement="auto"
                  overlay={<Tooltip {...props}>Subir archivo</Tooltip>}
                >
                  <Button
                    size="sm"
                    variant="link"
                    type="button"
                    className="text-primary btn rounded-pill"
                    onClick={() =>
                      onSaveDoc(value.row.original, value.row.index)
                    }
                  >
                    <i className="material-icons">upload</i>
                  </Button>
                </OverlayTrigger>
              </>
            )}
          {value.row.original.archivo_evidencia && (
            <>
              <OverlayTrigger
                placement="auto"
                overlay={<Tooltip {...props}>Descargar archivo</Tooltip>}
              >
                <div>
                  <LinkDescargaListGD
                    id={value.row.original.id}
                    filters={{
                      email: email,
                      id: value.row.original.list_archivo_evidencia[0]
                        .id_documento,
                      llave: value.row.original.list_archivo_evidencia[0].llave,
                    }}
                    origen={value.row.original.list_archivo_evidencia[0].origen}
                    icono={<i className="material-icons">file</i>}
                    cType={
                      value.row.original.list_archivo_evidencia[0].contentTypeGD
                    }
                  />
                </div>
              </OverlayTrigger>
            </>
          )}
        </div>
      ),
    },
  ];

  // Métodos
  const getADisciplinaryAction = (
    offs = offset,
    lim = limit,
    tipo = tipoBusqueda.id,
    filt = filter,
    viw = view
  ) =>
    dispatch(
      getDisciplinaryActions({
        offset: offset,
        limit: limit,
        tipo_busqueda: "empleado__codigo",
        filter: employeeCode,
        vista: viw,
      })
    );

  useEffect(() => {
    if (userRoles.length > 0) {
      const rolActual = userRoles.filter(
        (usr) =>
          usr === "jefe" ||
          usr === "administrador" ||
          usr === "Encargado_Sanciones" ||
          usr === "alta_direccion"
      )[0];
      setView(rolActual);
      getADisciplinaryAction(offset, limit, tipoBusqueda.id, filter, rolActual);
      /*       dispatch(getDisciplinaryCasesAll({ vista: view })); */
      dispatch(getStatuss({}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, filter, limit, offset, userRoles]);

  useEffect(() => {
    dispatch(getAreas());
    dispatch(getCarpetas());
  }, [dispatch]);

  useEffect(() => {
    if (areas && areas.length > 0 && carpetas && carpetas.length > 0) {
      const oCarpeta = carpetas.find(
        (item) => item.descripcion.toLowerCase() === carpeta.toLowerCase()
      );
      dispatch(
        getSubNiveles({
          areaid: areas[0].id,
          ceid: oCarpeta.id,
        })
      );
    }
  }, [areas, carpeta, carpetas, dispatch]);

  const onEdit = (item, index) => {
    dispatch(resetDisciplinaryCase());
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
  };

  const onSaveDoc = (item, index) => {
    if (item.archivos_gestor) {
      setEdit(true);
      setEditItemGD(item.list_archivo_evidencia);
    } else {
      setEdit(false);
      setEditItemGD({});
    }
    setHabilitarFecha(false);
    setEditItem(item);
    setEditItemIndex(index);
    setShowModalView(true);
    setValidatedDoc(false);
  };

  const onOpenModalCase = (item, index) => {
    setIndex(index);
    if (item.caso_disciplinario) {
      setEdit(true);
      setEditItem(item);
    } else {
      setEdit(false);
      setEditItem({});
    }
    setShowModalCase(true);
  };

  const onSearchRole = (e) => {
    e.preventDefault();
    setView(e.currentTarget.value);
    setFilter("");
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getADisciplinaryAction(oOffset, limit, filter, e.currentTarget.value);
    dispatch(getDisciplinaryCasesAll({ vista: e.currentTarget.value }));
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteDisciplinaryActions(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const onSubmitDocImg = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      if (
        e.target.documentos.files.length > 0 &&
        e.target.fechaDoc.value === ""
      ) {
        setValidFechaDoc(true);
      }
      setValidatedDoc(true);
      return;
    }
    if (
      e.target.documentos.files.length > 0 &&
      e.target.fechaDoc.value === ""
    ) {
      setValidFechaDoc(true);
      setValidatedDoc(true);
      return;
    }
    if (e.target.documentos.files.length === 0) {
      return;
    }

    const oArea = areas.find(
      (item) => item.descripcion.toLowerCase() === area.toLowerCase()
    );
    const oCarpeta = carpetas.find(
      (item) => item.descripcion.toLowerCase() === carpeta.toLowerCase()
    );

    const filebase64 = await getBase64(e.target.documentos.files[0]);
    const fileName = e.target.documentos.files[0].name;
    const fName = String(fileName)
      .substring(0, String(fileName).lastIndexOf("."))
      .replace(/\W/g, "");
    const fExt = `.${String(fileName).substr(
      fileName.lastIndexOf(".") + 1 - fileName.length
    )}`;
    const aFileBase = String(filebase64).split(",");

    var chk = new FormData();
    chk.append(
      "id_empleado",
      parseInt(editItem.list_caso_disciplinario[0].list_codigo_empleado[0].id)
    );
    chk.append("tipo_documento", tipoDocumento);
    chk.append("archivo", aFileBase[1]);
    chk.append("contentTypeGD", `${aFileBase[0]},`);
    chk.append("origen", fName + fExt);
    chk.append("extension", fExt);
    chk.append("tipo_documento_GD", e.target.tipoDocumentDesc.value);
    chk.append("descripcion", e.target.documentDesc.value);
    chk.append("fecha", moment().format("YYYY-MM-DD"));
    chk.append("id_area", oArea.id);
    chk.append("id_carpeta_encabezado", oCarpeta.id);
    chk.append(
      "empresa",
      editItem.list_caso_disciplinario[0].list_codigo_empleado[0].empresa[0]
    );
    chk.append(
      "zona",
      editItem.list_caso_disciplinario[0].list_codigo_empleado[0]
        .Division_Personal_List[0].descripcion
    );
    chk.append("id_registro", parseInt(editItem.id));
    const exist = e.target.documentos.files.length > 0;
    if (editItem && editItem.archivo_evidencia) {
      dispatch(
        editDisciplinaryActionDocGD(
          chk,
          editItem,
          editItemIndex,
          parseInt(props.type),
          editItem.archivo_evidencia,
          exist
        )
      );
    } else {
      dispatch(
        saveDisciplinaryActionDocGD(
          chk,
          editItem,
          parseInt(editItemIndex),
          parseInt(props.type),
          exist
        )
      );
    }
    e.target.reset();
    setEditItem({});
    setShowModalView(false);
  };

  const handleBack = () => {
    onClose();
    toggleButtonsVisibility();
  };

  const handleDownloadAll = () => {
    const data = disciplinaryActions.map((item) => ({
      caso_disciplinario:
        item.list_caso_disciplinario[0]?.caso_disciplinario || "",
      codigo_empleado:
        item.list_caso_disciplinario[0]?.list_codigo_empleado[0]?.codigo || "",
      colaborador:
        item.list_caso_disciplinario[0]?.list_codigo_empleado[0]?.nombre || "",
      accion_disciplinaria:
        item.list_caso_disciplinario[0]?.list_id_motivo[0]?.nombre || "",
      medida_disciplinaria: item.list_medida[0]?.nombre || "",
      descripcion: item.list_caso_disciplinario[0]?.descripcion || "",
      aplicado_por: item.list_aplicada_por[0]?.first_name
        ? `${item.list_aplicada_por[0].first_name} ${item.list_aplicada_por[0].last_name}`
        : item.list_aplicada_por[0]?.first_name || "",
      observacion: item.observacion || "",
      fecha_vencimiento: item.fecha_vencimiento
        ? moment(item.fecha_vencimiento).format("DD/MM/YYYY")
        : "",
      estatus: item.list_caso_disciplinario[0]?.list_estatus[0]?.nombre || "",
      calculo_prestaciones: item.calculo_prestaciones || "",
      autorizado_por: item.autorizado_por || "",
    }));

    return (
      <ExcelFile
        element={
          <Button
            variant="light"
            size="sm"
            className="rounded-circle"
            disabled={loading || saveLoading}
          >
            <i className="material-icons">file_download</i>
          </Button>
        }
        filename="Historial_Acciones_Disciplinarias"
      >
        <ExcelSheet data={data} name="Acciones Disciplinarias">
          <ExcelColumn label="Caso Disciplinario" value="caso_disciplinario" />
          <ExcelColumn label="Código Empleado" value="codigo_empleado" />
          <ExcelColumn label="Colaborador" value="colaborador" />
          <ExcelColumn
            label="Acción Disciplinaria"
            value="accion_disciplinaria"
          />
          <ExcelColumn
            label="Medida Disciplinaria"
            value="medida_disciplinaria"
          />
          <ExcelColumn label="Descripción" value="descripcion" />
          <ExcelColumn label="Aplicado Por" value="aplicado_por" />
          <ExcelColumn label="Observación" value="observacion" />
          <ExcelColumn label="Fecha de Vencimiento" value="fecha_vencimiento" />
          <ExcelColumn
            label="Cálculo de Prestaciones"
            value="calculo_prestaciones"
          />
          <ExcelColumn label="Estatus" value="estatus" />
          <ExcelColumn label="Autorizado Por" value="autorizado_por" />
        </ExcelSheet>
      </ExcelFile>
    );
  };

  return (
    <>
      <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip id="tooltip-back">Volver a reincidencias</Tooltip>}
        >
          <Button
            variant="light"
            size="sm"
            className="rounded-circle"
            disabled={loading || saveLoading}
            onClick={handleBack}
          >
            <i className="material-icons">arrow_back</i>
          </Button>
        </OverlayTrigger>
        <Form>
          <Row className="justify-content-end align-items-center flex-nowrap">
            <Col>
              <h6>HISTORIAL ACCIONES DISCIPLINARIAS</h6>
              <span>
                {employeeName} - {employeeCode}
              </span>
            </Col>

            <Col xs="auto">
              <ButtonGroup>{handleDownloadAll()}</ButtonGroup>
            </Col>
          </Row>
        </Form>
      </div>
      <Row className="mx-2 px-1 justify-content-start align-items-center flex-nowrap">
        {userRoles.filter(
          (usr) =>
            usr === "jefe" ||
            usr === "administrador" ||
            usr === "Encargado_Sanciones" ||
            usr === "alta_direccion"
        ).length > 1 ? (
          <>
            <Col xs="auto">
              <h6>
                <b>Ver como:</b>
              </h6>
            </Col>
            <Col xs="auto">
              <Form.Control
                as="select"
                name="filter"
                id="filter"
                placeholder="Buscar"
                className="rounded-pill form-control-sm"
                onChange={onSearchRole}
                style={{ minWidth: "174px" }}
              >
                {userRoles
                  .filter(
                    (usr) =>
                      usr === "jefe" ||
                      usr === "administrador" ||
                      usr === "Encargado_Sanciones" ||
                      usr === "alta_direccion"
                  )
                  .map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
              </Form.Control>
            </Col>
          </>
        ) : null}
      </Row>
      {loading ? (
        <div className="d-flex justify-content-center">
          <Spinner
            animation="border"
            role="status"
            className="d-flex justify-content-center"
          />
        </div>
      ) : (
        disciplinaryActionsLength > 0 && (
          <>
            <Card className="border-0">
              <Card.Body className="px-1 px-sm-2">
                <CustomTable columns={columns} data={disciplinaryActions} />
              </Card.Body>
            </Card>
            <CustomPagint
              limit={limit}
              setLimit={setLimit}
              offset={offset}
              setOffset={setOffset}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              dataLenght={disciplinaryActionsLength}
              pages={pages}
              pagFunc={getADisciplinaryAction}
            />
          </>
        )
      )}
      {!loading &&
        disciplinaryActionsLength === 0 &&
        disciplinaryActionsError === "" && (
          <Alert variant="info" className="my-4">
            Aún no hay registros, comience agregando algunos
          </Alert>
        )}
      {!!disciplinaryActionsError && (
        <Alert variant="danger" className="my-2">
          {disciplinaryActionsError}
        </Alert>
      )}

      <DisciplinaryActionsModal
        editItem={editItem}
        show={showModal}
        handleClose={() => setShowModal(false)}
        edit={edit}
        index={index}
        carpeta={carpeta}
        tipoDocumento={tipoDocumento}
        tipoDocumentoGD={tipoDocumentoGD}
        descripcion={descripcion}
        area={area}
        email={email}
        areas={areas}
        carpetas={carpetas}
        view={view}
      />
      <DisciplinaryCaseModal
        editItem={editItem}
        show={showModalCase}
        handleClose={() => setShowModalCase(false)}
        edit={edit}
        index={index}
      />
      <Modal
        size="md"
        show={showModalView}
        onHide={() => {
          setShowModalView(false);
        }}
        backdrop="static" // Evita que la modal se cierre al hacer clic fuera de ella
        keyboard={false} // Evita que la modal se cierre al presionar la tecla "Esc"
      >
        <Form onSubmit={onSubmitDocImg} noValidate validated={validatedDoc}>
          <Modal.Header closeButton={!saveLoading}>
            <Modal.Title>
              <h4 className="font-weight-bold text-uppercase m-0">
                <i className="material-icons">file_upload</i>
                &nbsp;Subir archivo
              </h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!!formErrors && (
              <Alert variant="danger" className="my-2">
                {formErrors}
              </Alert>
            )}
            {!!subNivelesError && (
              <Alert variant="danger" className="my-2">
                {subNivelesError}
              </Alert>
            )}
            <Form.Group as={Row}>
              <Form.Label column sm="12" md="4">
                Documento
              </Form.Label>
              <Col sm="12" md="8">
                <Form.File.Input
                  // accept="image/*"
                  name="documentos"
                  className="py-1"
                  required
                  disabled={
                    loadingAreas ||
                    loadingCarpetas ||
                    saveDocsLoading ||
                    !(
                      subNiveles &&
                      subNiveles.subNivelTipoDocList &&
                      subNiveles.subNivelTipoDocList.length > 0
                    ) ||
                    !(
                      subNiveles &&
                      subNiveles.subNivelDescripcionList &&
                      subNiveles.subNivelDescripcionList.length > 0
                    )
                  }
                  onChange={(e) => {
                    if (e.currentTarget.files.length > 0) {
                      setHabilitarFecha(true);
                    } else {
                      setHabilitarFecha(false);
                    }
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  <ul className="list-unstyled">
                    <li>**Es requerido un archivo de menor peso.</li>
                    <li>**Es requerido un archivo con formato pdf o imagen.</li>
                  </ul>
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm="12" md="4">
                Descripción
              </Form.Label>
              <Col sm="12" md="8">
                <Form.Control
                  as="select"
                  name="documentDesc"
                  className="rounded-pill"
                  required={validFechaDoc}
                  defaultValue={edit ? editItemGD.Descripcion : null}
                  placeholder="Descripción del documento"
                  disabled={!habilitarFecha}
                >
                  <option value="" selected disabled>
                    Seleccione un descripción
                  </option>
                  {subNiveles &&
                    subNiveles.subNivelDescripcionList &&
                    subNiveles.subNivelDescripcionList.map((item, index) => (
                      <option key={index} value={item.descripcion}>
                        {item.descripcion}
                      </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm="12" md="4">
                Tipo de documento
              </Form.Label>
              <Col sm="12" md="8">
                <Form.Control
                  as="select"
                  name="tipoDocumentDesc"
                  className="rounded-pill"
                  required={validFechaDoc}
                  placeholder="Descripción del documento"
                  disabled={!habilitarFecha}
                >
                  <option value="" selected disabled>
                    Seleccione un tipo de documento
                  </option>
                  {subNiveles &&
                    subNiveles.subNivelTipoDocList &&
                    subNiveles.subNivelTipoDocList.map((item, index) => (
                      <option key={index} value={item.descripcion}>
                        {item.descripcion}
                      </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm="12" md="4">
                Fecha de entrega
              </Form.Label>
              <Col sm="12" md="8">
                <Form.Control
                  name="fechaDoc"
                  className="rounded-pill"
                  required={validFechaDoc}
                  type="date"
                  disabled={!habilitarFecha}
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            {editItem && editItem.archivo_evidencia ? (
              <>
                <h6 className="text-muted ml-3">Archivo actual</h6>
                <ul className="list-unstyled">
                  <LinkDescargaGD
                    id={editItem.id}
                    filters={{
                      email: email,
                      id: editItem.list_archivo_evidencia[0].id_documento,
                      llave: editItem.list_archivo_evidencia[0].llave,
                    }}
                    origen={editItem.list_archivo_evidencia[0].origen}
                    cType={editItem.list_archivo_evidencia[0].contentTypeGD}
                  />
                </ul>
              </>
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => {
                if (!saveLoading) {
                  setShowModalView(false);
                }
              }}
              disabled={saveLoading}
            >
              Cerrar
            </Button>
            <Button
              className="rounded-pill"
              disabled={
                loadingDocs ||
                loadingAreas ||
                loadingCarpetas ||
                saveDocsLoading ||
                areas === "" ||
                (areas && areas.length === 0) ||
                carpetas === "" ||
                (carpetas && carpetas.length === 0)
              }
              variant="primary"
              type="submit"
            >
              {loadingDocs ||
              loadingAreas ||
              loadingCarpetas ||
              saveDocsLoading ||
              saveLoading ? (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : null}
              Guardar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default ReincidenciasAccionesEmployee;
